export const isTbd = (value: string | null) =>
    typeof value !== 'string' ||
    value.toUpperCase() === 'TBD' ||
    value.length === 0 ||
    value === '?'
;
